import React, { Component } from 'react';
import classNames from 'classnames';

import { enableScroll, disableScroll } from '../../../services/body-scroll';
import styles from './MobileFullScreenModal.scss';

type MobileFullScreenModalProps = {
  className: string;
  children: JSX.Element;
  header: JSX.Element;
  isAnimated: boolean;
  hasInnerScroll: boolean;
};

export class MobileFullScreenModal extends Component<MobileFullScreenModalProps> {
  static defaultProps = {
    isAnimated: true,
    hasInnerScroll: true,
  };

  componentDidMount() {
    disableScroll();
  }

  componentWillUnmount() {
    enableScroll();
  }

  render() {
    const { className, children, isAnimated, hasInnerScroll } = this.props;
    const containerClassName = classNames(styles.container, {
      [styles.isAnimated]: isAnimated,
      [styles.disableScroll]: !hasInnerScroll,
    });
    const contentClassName = classNames(styles.content, className);

    return (
      <main className={containerClassName}>
        <div className={styles.header}>
          {React.cloneElement(this.props.header)}
        </div>
        <div className={styles.scrollable}>
          <div className={contentClassName}>{children}</div>
        </div>
      </main>
    );
  }
}

export default MobileFullScreenModal;
